// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"b84bb7cd","220":"fbcb7134","448":"40ca6531","830":"881f150d","960":"69bfab93","981":"1533858f"}[chunkId] + ".chunk.js";
};